'use strict';

/* globals config, $ */

require([config.relative_path + '/plugins/nodebb-plugin-memory-game/static/vendor/vue.js'], function (Vue) {
	var internals = {};

	Vue.component('game-creator-panel', {
		props: ['initData'],
		data: function () {
			return {
				game: this.initData.game,
				levelImagesCount: [4, 9, 16],
			};
		},
		mounted: function () {
			if (this.game.images.length === 0) {
				this.addEmptyImages(this.levelImagesCount[0]);
			}
		},
		methods: {
			onLevelChange: function (event) {
				this.game.level = parseInt(event.target.value, 10);

				var currentLevelImagesCount = this.levelImagesCount[this.game.level];

				if (this.game.images.length > currentLevelImagesCount) {
					this.game.images.splice(currentLevelImagesCount, this.game.images.length - currentLevelImagesCount);
				} else {
					this.addEmptyImages(currentLevelImagesCount - this.game.images.length);
				}
			},
			addEmptyImages: function (count) {
				for (var i = 0; i < count; i++) {
					this.game.images.push({ url: '' });
				}
			},
		},
		template:
		'<div>' +
			'<div class="row">' +
				'<div class="col-xs-2 text-right" style="padding-top: 9px">' +
					'Select game level:' +
				'</div>' +
				'<div class="col-xs-10">' +
					'<select v-model="game.level" @change="onLevelChange($event)" class="form-control">' +
						'<option value="0">Level Easy (4 images)</option>' +
						'<option value="1">Level Medium (9 images)</option>' +
						'<option value="2">Level Hard (16 images)</option>' +
					'</select>' +
				'</div>' +
			'</div>' +
			'<div class="row mt-4">' +
				'<game-image v-for="image in game.images" :image="image" :init-data="initData"></game-image>' +
			'</div>' +
		'</div>',
	});

	internals.expandChapter = function (chapter) {
		setTimeout(function () {
			$('[data-toggle="collapse"]', chapter.el).click();
		}, 150);
	};
});
